import { readonly } from 'vue'
import user from './user'
import subjects from './subjects'
import modalQueue from './modalQueue'
import basket from './basket'

const store = readonly({
  user,
  subjects,
  modalQueue,
  basket
})

export default store
